import {Grid} from '@yandex-delivery/blocks'
import React from 'react'

import {default as HeaderButton} from '../header-button/HeaderButton'
import ChevronIcon from '../icons/ChevronIcon'
import {ControlPanelMobileProps} from './ControlPanel.types'
import {mobileClasses} from './ControlPanel@mobile.classes'

export function ControlPanel({controlPanelData}: ControlPanelMobileProps) {
  return (
    <Grid alignItems="center" className={mobileClasses.root} wrap="nowrap" container>
      {controlPanelData.map((item, index) => (
        <Grid key={index} item>
          <HeaderButton {...item.buttonProps}>
            {item.label}
            <ChevronIcon className={mobileClasses.icon} />
          </HeaderButton>
        </Grid>
      ))}
    </Grid>
  )
}
